module.exports = __webpack_public_path__ + "a50e105946b20ccb9181060c59fb41d1.png";